module.exports = __webpack_public_path__ + "img/feature2-1.5d231a79.png";